import { useEffect, useState } from "react";
import type { CustomerDto, MaterialDto, WorkCenterDto } from "@grizzly/shared";
import { api } from "./apiClient.js";

export interface CatalogOptions {
  customers: CustomerDto[];
  workCenters: WorkCenterDto[];
  materials: MaterialDto[];
}

export function useCatalogOptions(): CatalogOptions {
  const [options, setOptions] = useState<CatalogOptions>({
    customers: [],
    workCenters: [],
    materials: [],
  });

  useEffect(() => {
    let active = true;
    Promise.all([api.listCustomers(), api.listWorkCenters(), api.listMaterials()])
      .then(([c, w, m]) => {
        if (!active) return;
        setOptions({ customers: c.items, workCenters: w.items, materials: m.items });
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, []);

  return options;
}
